import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ size = 'medium', message = 'Loading...', overlay = false }) => {
  const spinnerSize = {
    small: 'spinner-border-sm',
    medium: '',
    large: 'spinner-border-lg'
  };

  const baseClasses = "text-center py-4";
  const overlayClasses = overlay 
    ? "position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-white bg-opacity-75"
    : "";
  
  const containerStyle = {
    zIndex: 9999
  };

  return (
    <div 
      className={`${baseClasses} ${overlayClasses}`}
      style={containerStyle}
    >
      <div className={`spinner-border text-secondary ${spinnerSize[size]}`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {message && <p className="mt-2">{message}</p>}
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  message: PropTypes.string,
  overlay: PropTypes.bool
};

export default Loader;